export type ProjectListMapCursor = 'grab' | 'grabbing' | 'pointer';

type ProjectListMapCursorState = {
  dragging: boolean;
  /** Pin, cluster, or footprint under the pointer. */
  overFeature: boolean;
};

/**
 * Canvas cursor for the project-list map.
 * An active drag stays `grabbing` over markers and clusters. After the drag,
 * a feature under the pointer is `pointer` and the open map is `grab`.
 */
export const resolveProjectListMapCursor = ({
  dragging,
  overFeature,
}: ProjectListMapCursorState): ProjectListMapCursor => {
  if (dragging) return 'grabbing';
  if (overFeature) return 'pointer';
  return 'grab';
};
